module.exports = __webpack_public_path__ + "static/dark-thumb-de97ccfdd36b6fa4ac345894f1593737.jpg";